import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import SVGInject from "@iconfu/svg-inject";
import {wpAdminbar} from "./components/wp.adminbar";
import {blockPosts} from "./blocks/block.posts";
import {blockStats} from "./blocks/block.stats";
import {blockVideoCta, blockVideoCtaButton} from "./blocks/block.video-cta";
import {wpSearch} from "./components/wp.search";
import {blockVideo} from "./blocks/block.video";

document.addEventListener("DOMContentLoaded", function () {
    window.Alpine = Alpine;
    SVGInject(document.querySelectorAll("img.injectable"));
    wpAdminbar();
    wpSearch();
    blockPosts();
    blockStats();
    blockVideoCta();
    blockVideo()

    Alpine.store('main', {
        mobile_menu_is_open: false,
        search_is_open: false
    })

    Alpine.plugin(focus)

    Alpine.start()
});